<template>
    <div class="appointment-edit-modal">

        <data-form-modal :modal-id="modalId"
                         :title="$i18n.gt('LABEL_EDIT_APPOINTMENT')"
                         :save-button-label="$i18n.gt('LABEL_SAVE')"
                         :field-model="appointmentFields"
                         :field-groups="fieldGroups"
                         :model-instance="appointmentInstance"
                         :on-cancel-handler="cancelModal"
                         :on-submit-handler="save">

            <!-- additional content for modal -->

            <template v-slot:header>
                <div>
                    Practitioner:
                    {{ practitionerName }}
                </div>
            </template>

<!--            <template v-slot:modal-footer-extra>
                <b-btn class="btn-delete"
                       @click="console.log('hi')">
                    {{ $i18n.gt('LABEL_DELETE_GOAL') }}
                    <shs-icon name="delete"></shs-icon>
                </b-btn>
            </template>-->

        </data-form-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import AppointmentFields from '@/models/Appointment'
import moment from 'moment'

export default Vue.extend({
    name: 'AppointmentEditModal',
    props: {
        practitionerView: Boolean,
        reloadCalendar: Function,
        reloadSelected: Function,
    },
    data() {
        return {
            id: null,
            start: null,
            end: null,
            practitionerName: null,
            appointmentInstance: {},
            appointmentFields: AppointmentFields,
            fieldGroups: [['participant_id', 'date', 'startTime', 'endTime']],
            emrReadEnabled: false,
            emrWriteEnabled: false
        }
    },
    computed: {
        modalId() {
            return `appointmentModal`
        }
    },
    mounted() {
        if (this.practitionerView) {
            this.$api.getItem(this, 'participant', this.$store.state.currentUser.participantId, ['fullname','current_practitioner_id']).then((participant) => {
                if (participant.current_practitioner_id) {
                    this.$api.emrScope(this, {
                        practitioner: participant.current_practitioner_id
                    })
                        .then((scope) => {
                            if (scope) {
                                this.emrReadEnabled = scope.includes('appointment.read')
                                this.emrWriteEnabled = scope.includes('appointment.write')
                            }
                        })
                }
            })
        } else {
            this.$api.emrScope(this, {
                participant: this.$store.state.currentUser.participantId
            })
                .then((scope) => {
                    if (scope) {
                        this.emrReadEnabled = scope.includes('appointment.read')
                        this.emrWriteEnabled = scope.includes('appointment.write')
                    }
                })
        }
    },
    methods: {
        setAppointmentTime() {
            this.appointmentInstance.date = moment(this.start).format('YYYY-MM-DD')
            this.appointmentInstance.startTime = moment(this.start).format('HH:mm')
            this.appointmentInstance.endTime = moment(this.end).format('HH:mm')
        },
        showModal() {
            this.$bvModal.show(this.modalId)
        },
        cancelModal() {
            this.$bvModal.hide(this.modalId)
        },
        resetModelInstance() {
            this.appointmentInstance = {}
            if (this.practitionerView) {
                this.appointmentFields.fields.practitioner_id.disabled = true
                this.$api.getItem(this, 'participant', this.$store.state.currentUser.participantId, ['fullname','current_practitioner_id']).then((part) => {
                    this.practitionerName = part.fullname
                    this.appointmentInstance = {practitioner_id: part.current_practitioner_id}
                })
            }
        },
        parseTimes() {
            this.appointmentInstance.start = this.appointmentInstance.date + ' ' + this.appointmentInstance.startTime
            this.appointmentInstance.end = this.appointmentInstance.date + ' ' + this.appointmentInstance.endTime
        },
        async save() {
            this.parseTimes()
            if (this.appointmentInstance.participant_id) {
                this.appointmentInstance.participant_id = this.appointmentInstance.participant_id.id
            }
            let result = null
            if (!this.id){
                result = await this.$api.createItem(this, 'appointment', this.appointmentInstance)
            } else {
                this.appointmentInstance.id = this.id
                result = await this.$api.updateItem(this, 'appointment', this.appointmentInstance, false)
            }
            if (this.emrReadEnabled && result && result.body && result.body.id) {
                //  check participant EMR status
                if (this.appointmentInstance.participant_id) {
                    let participant = await this.$api.getItem(this, 'participant', this.appointmentInstance.participant_id, ['fullname']).then((participant) => {
                        if (!participant) {
                            this.$toasted.error('Unable to load participant record for EMR calendar addition', {duration: 5000})
                        } else if (!participant.emr_id) {
                            this.$toasted.error(`Patient "${participant.fullname}" does not have an EMR record; synchronizing calendar will show an available appointment`, {duration: 5000})
                        }
                    })
                }
                //  must await since otherwise calendar is not updated
                this.$utils.handleEMRError(await this.$api.emrUpdate(this, 'appointment', result.body.id))
            }
            this.resetModelInstance()
            this.reloadCalendar()
            if (this.id) {
                this.reloadSelected(this.id)
            }
        },
    },
    created() {
        this.resetModelInstance()
    }
})
</script>

<style lang="scss">


    .b-form-timepicker > .btn {
        padding: 0 .5em;
        color: black;
    }

    fieldset .dropdown-menu .btn {
        color: black;
    }

    .b-form-timepicker b-icon .btn:hover {
        color: black
    }


</style>
